import { useSearchParams } from 'react-router-dom'

const useParams = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    const add = (key: string, value: string) => {
        searchParams.set(key, value)
        setSearchParams(searchParams)
    }

    const remove = (key: string) => {
        searchParams.delete(key)
        setSearchParams(searchParams)
    }

    const useQuery = () => {
        return new URLSearchParams(searchParams)
    }

    const useUrlParamiters = () => {
        return {
            startdate: useQuery().get("startdate"),
            enddate: useQuery().get("enddate"),
            orgUnit: useQuery().get("orgUnit"),
            orgUnitName: useQuery().get("orgUnitName"),
            parentId: useQuery().get("parentId"),
        }
    }

    return { add, remove, useQuery, useUrlParamiters }
}
export { useParams }
